import { motion } from 'framer-motion';
import Slider from './GallerySlider';
import { GALLERY } from '../constants/config';
import { floatingOrb, floatingOrbReverse } from '../constants/animations';
import { Reveal } from './Reveal';

const BUBBLES = [
  { className: 'left-[8%] top-[18%] h-20 w-20 bg-indigo-400/15', variant: floatingOrb, duration: 10 },
  { className: 'left-[22%] top-[62%] h-12 w-12 bg-sky-300/15', variant: floatingOrbReverse, duration: 13 },
  { className: 'right-[14%] top-[24%] h-28 w-28 bg-blue-400/12', variant: floatingOrbReverse, duration: 15 },
  { className: 'right-[26%] top-[68%] h-16 w-16 bg-indigo-300/15', variant: floatingOrb, duration: 11 },
  { className: 'left-1/2 top-[10%] h-10 w-10 bg-sky-400/15', variant: floatingOrb, duration: 9 },
  { className: 'right-[8%] bottom-[12%] h-24 w-24 bg-indigo-500/12', variant: floatingOrbReverse, duration: 16 },
];

function GallerySection() {
  return (
    <section
      className="relative w-full overflow-hidden bg-gradient-to-b from-indigo-950 via-blue-950 to-indigo-950 py-12 md:py-20"
      id="gallery"
      aria-label="Project gallery"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-15"
        aria-hidden="true"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 20%, rgba(99,102,241,0.35), transparent 40%), radial-gradient(circle at 80% 80%, rgba(59,130,246,0.25), transparent 35%)',
        }}
      />

      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <motion.div
          className="absolute left-1/4 top-1/3 h-64 w-64 rounded-full bg-indigo-400/10 blur-2xl"
          animate={floatingOrb.animate}
          transition={{ ...floatingOrb.transition, duration: 12 }}
        />

        {BUBBLES.map((bubble, index) => (
          <motion.span
            key={index}
            className={`absolute rounded-full border border-white/10 blur-[1px] ${bubble.className}`}
            animate={bubble.variant.animate}
            transition={{ ...bubble.variant.transition, duration: bubble.duration }}
          />
        ))}
      </div>

      <div className="relative mx-auto w-full max-w-[1800px] px-4 sm:px-6 lg:px-10 xl:px-14 2xl:px-20">
        <Reveal
          className="mx-auto mb-8 flex max-w-2xl flex-col items-center gap-2 text-center md:mb-10 xl:mx-0 xl:items-start xl:text-left"
          variant="slideUp"
          animateOnMount
        >
          <div className="text-[1.15rem] font-semibold uppercase tracking-[0.2em] text-indigo-300 xl:text-[1.35rem]">
            {GALLERY.eyebrow}
          </div>

          <h2 className="text-[1.575rem] font-extrabold leading-[1.25] tracking-tight text-white sm:text-[1.8rem] md:text-[2.25rem] xl:text-[2.475rem] 2xl:text-[2.8125rem]">
            {GALLERY.title}
          </h2>

          <p className="text-[0.72rem] leading-relaxed text-indigo-200 sm:text-[0.81rem] xl:text-[1.0125rem]">
            {GALLERY.subtitle}
          </p>
        </Reveal>

        <Reveal variant="scaleUp" index={1}>
          <Slider />
        </Reveal>
      </div>
    </section>
  );
}

export default GallerySection;
